export const constants = {};

export const OTHER_SPORT = {
  id: 'other_sport_id',
  name: 'Other',
  fileUrl: '/images/other-sport-bg-icon.svg',
};
